import { createContext } from "react";

import type { AuthTokenSnapshot, LicensingRole } from "@/auth/token-session";

export type AuthStatus = "loading" | "authenticated" | "anonymous" | "forbidden" | "unavailable";

export type AuthContextValue = {
  status: AuthStatus;
  tokenReady: boolean;
  userName: string;
  roles: ReadonlySet<LicensingRole>;
  login: (redirectPath?: string) => void;
  logout: () => void;
  getTokenSnapshot: (forceRefresh?: boolean) => Promise<AuthTokenSnapshot>;
  currentTokenSnapshot: () => AuthTokenSnapshot | null;
  onTerminalUnauthorized: (rejected: AuthTokenSnapshot) => void;
};

export const AuthContext = createContext<AuthContextValue | null>(null);
